import React, { useState } from "react";
import {
Box,
Card,
Typography,
Button,
Checkbox,
FormControlLabel,
DialogTitle,
DialogContent,
DialogActions,
Snackbar,
Alert,
CircularProgress
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import { adminFetch } from "../services/adminFetch";
import ResponsiveDialog from "../components/ResponsiveDialog";
import { adminPageSx } from "../utils/adminResponsive";

export default function SuspendUser(){

const { state } = useLocation();
const navigate = useNavigate();

const user = state?.user;


const isSuspended = user?.status === "suspended";

const [notify,setNotify] = useState(true);
const [open,setOpen] = useState(false);
const [loading,setLoading] = useState(false);


const [snackbar,setSnackbar] = useState({
open:false,
message:"",
severity:"success"
});

const showSnackbar = (message,severity="success")=>{
setSnackbar({open:true,message,severity});
};

const handleCloseSnackbar = ()=>{
setSnackbar({...snackbar,open:false});
};




const handleAction = async () => {

setLoading(true);

try{

const endpoint = isSuspended
? "/api/user/unsuspend-user"
: "/api/user/suspend-user";

const data = await adminFetch(endpoint,
    {
      method:"PUT", 
      body:JSON.stringify({
      user_id:user.id,
      notify
   })   
    }
)

if(!data.status){
showSnackbar(data.message || "Operation failed","error");
setLoading(false);
return;
}



showSnackbar(
data.message ||
(isSuspended
? "User unsuspended successfully"
: "User suspended successfully"
),
"success"
);

setTimeout(()=>{
navigate("/admin/users");
},2000);

}catch(err){
console.log(err);
showSnackbar("Server error. Try again.","error");
}

setLoading(false);
setOpen(false);
};


return(

<Box sx={{ ...adminPageSx }}>

<Card sx={{ p:{ xs:2, sm:4 }, maxWidth:600, mx:"auto" }}>

<Typography
variant="h5"
sx={{
mb:2,
color: isSuspended ? "#2e7d32" : "#ed6c02"
}}
>
{isSuspended ? "Restore User" : "Suspend User"}
</Typography>

<Typography sx={{mb:2}}>
User: <b>{user?.email}</b>
</Typography>

<Typography sx={{mb:2, fontWeight:500}}>
Current Status:{" "}
<span style={{
color: isSuspended ? "#f44336" : "#4caf50"
}}>
{user?.status}
</span>
</Typography>

<FormControlLabel
control={
<Checkbox
checked={notify}
onChange={(e)=>setNotify(e.target.checked)}
/>
}
label={`${isSuspended ? "Notify user of restoration" : "Notify user of suspension"} (${user?.email})`}
/>

<Button
fullWidth
variant="contained"
sx={{
mt:3,
bgcolor: isSuspended ? "#2e7d32" : "#ed6c02"
}}
onClick={()=>setOpen(true)}
disabled={loading}
>
{isSuspended ? "Restore User" : "Suspend User"}
</Button>

</Card>




<ResponsiveDialog open={open} onClose={()=>setOpen(false)} maxWidth="xs">

<DialogTitle>
{isSuspended ? "Confirm Restore" : "Confirm Suspension"}
</DialogTitle>

<DialogContent>
{isSuspended
? "Are you sure you want to restore this user account?"
: "Are you sure you want to suspend this user account?"
}
</DialogContent>

<DialogActions>

<Button onClick={()=>setOpen(false)}>
No
</Button>

<Button
variant="contained"
sx={{
bgcolor: isSuspended ? "#2e7d32" : "#ed6c02"
}}
onClick={handleAction}
disabled={loading}
>
{loading ? (
<CircularProgress size={20} sx={{color:"#fff"}}/>
) : (
isSuspended ? "Restore" : "Yes"
)}
</Button>

</DialogActions>

</ResponsiveDialog>




<Snackbar
open={snackbar.open}
autoHideDuration={4000}
onClose={handleCloseSnackbar}
anchorOrigin={{vertical:"top",horizontal:"center"}}
>
<Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
{snackbar.message}
</Alert>
</Snackbar>

</Box>

);

}
